import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { MaximizeDialogButtonModule } from '@portal-core/general/components/maximize-dialog-button/maximize-dialog-button.module';
import { SelfTruncatingPathModule } from '@portal-core/general/components/self-truncating-path/self-truncating-path.module';
import { FlareFileReviewerModule } from '@portal-core/reviews/components/flare-file-reviewer/flare-file-reviewer.module';
import { ReviewEditSnippetDialogComponent } from './review-edit-snippet-dialog.component';

@NgModule({
  declarations: [
    ReviewEditSnippetDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTabsModule,
    MatDividerModule,
    LoaderModule,
    ErrorsExpansionPanelModule,
    FlareFileReviewerModule,
    SelfTruncatingPathModule,
    MaximizeDialogButtonModule
  ],
  exports: [
    ReviewEditSnippetDialogComponent
  ]
})
export class ReviewEditSnippetDialogModule { }
